import CachedResourceStore from '@/store/modules/CachedResourceStore'
import { Terminal } from '@/models/Terminal'

export default new CachedResourceStore<Terminal>(Terminal, {
	namespaced: true
})
